import { AnimateSharedLayout, motion } from 'framer-motion'
import { Box } from 'reoil'
import tabNavs from '../constants/tabNav'
import { useThemeValue } from '../store/themeState'
import { black } from '../theme'
import { RouteComponentProps, useMatch } from '@reach/router'
import { MAX_WIDTH } from '../constants/media'
import goto from '../utils/goto'
import useResponsive from '../hooks/useResponsive'

const TabNav: React.FC<RouteComponentProps> = () => {
  // const [curTab, setCurTab] = useState<string>(tabNavs[0].name)

  const match = useMatch(`/:nav/*`)

  const  nav = '/'  + (match ? match.nav : '' || '')

  type Tab = {
    name: string
    link: string
  }
  const handleClickTab = (tab: Tab)=>{
    goto(tab.link)
  }

  // 非首页非PC不显示
  const {isWide} = useResponsive()

  if(nav!=='/' && !isWide) {
    return <></>
  }

  return(
    <Box className='TabNav' height={41} color='text.body-white' fontSize={15} row center position='relative' style={{zIndex: 1}}>
      <Box className='wrapper' fullWidth height={41} position='fixed' borderBox bg={black[45]} style={{ backdropFilter: 'blur(8px)'}}>
        <Box maxWidth={MAX_WIDTH} mx='auto' fullWidth row height='100%' px={3}>
          <AnimateSharedLayout>
            {tabNavs.map((tab, i)=>(
              <Box key={tab.name} ml={i?[3, 4, 5]:undefined} height='100%' center pointer onClick={()=>handleClickTab(tab)}>
                {tab.name}
                {tab.link===nav && <Underline />}
              </Box>
            ))}
          </AnimateSharedLayout>
        </Box>
      </Box>
    </Box>
  )
}

const Underline = ()=>{
  const theme = useThemeValue()

  return <motion.div layoutId='' style={{
    width: '100%',
    height: 2,
    background: theme.colors.primary,
    position: 'absolute',
    bottom: 0
  }}>
  </motion.div>
}

export default TabNav
